import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { SnackbarProvider } from 'notistack';
import { StrictMode } from 'react';
import { CookiesProvider } from 'react-cookie';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import './index.css';
import { router } from './routes';
import { persistor, store } from './store/store';
import { theme } from './themes';
import { ThemeProvider } from '@mui/material';

import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <I18nProvider i18n={i18n}>
        <CookiesProvider>
          <PersistGate loading={null} persistor={persistor}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <SnackbarProvider
                autoHideDuration={3000}
                anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
              >
                <ThemeProvider theme={theme}>
                  <RouterProvider router={router} />
                </ThemeProvider>
              </SnackbarProvider>
            </LocalizationProvider>
          </PersistGate>
        </CookiesProvider>
      </I18nProvider>
    </Provider>
  </StrictMode>
);
